import {
  CREATE_DEEPFAKE_KEY_MEMBER_ASYNC,
  GET_DEEPFAKE_CONFIG_ASYNC,
  GET_DEEPFAKE_KEY_MEMBERS_ASYNC,
  GET_DEEPFAKE_MAILBOX_LIST_ASYNC,
  SET_DEEPFAKE_MAILBOX_LIST_PAGE,
  SET_DEEPFAKE_MAILBOX_LIST_VALUE,
  SET_EMPLOYEE_INFO,
  SET_EMPLOYEE_INFO_FIELD,
  UPDATE_DEEPFAKE_CONFIG_ASYNC,
  UPDATE_DEEPFAKE_KEY_MEMBER_ASYNC,
} from './constants'

export const getDeepfakeConfig = () => ({
  type: GET_DEEPFAKE_CONFIG_ASYNC.INITIATE,
})
export const getDeepfakeConfigSuccess = (data) => ({
  type: GET_DEEPFAKE_CONFIG_ASYNC.SUCCESS,
  payload: { data },
})
export const getDeepfakeConfigError = (error) => ({
  type: GET_DEEPFAKE_CONFIG_ASYNC.ERROR,
  error,
})

export const getDeepfakeMailboxList = ({ search, page }) => ({
  type: GET_DEEPFAKE_MAILBOX_LIST_ASYNC.INITIATE,
  payload: { search, page },
})
export const getDeepfakeMailboxListSuccess = (data) => ({
  type: GET_DEEPFAKE_MAILBOX_LIST_ASYNC.SUCCESS,
  payload: { data },
})
export const getDeepfakeMailboxListError = (error) => ({
  type: GET_DEEPFAKE_MAILBOX_LIST_ASYNC.ERROR,
  error,
})

export const updateDeepfakeConfig = (key) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key },
})
export const updateDeepfakeConfigSuccess = () => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.SUCCESS,
})
export const updateDeepfakeConfigError = (error) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.ERROR,
  error,
})

export const getDeepfakeKeyMembers = () => ({
  type: GET_DEEPFAKE_KEY_MEMBERS_ASYNC.INITIATE,
})
export const getDeepfakeKeyMembersSuccess = (data) => ({
  type: GET_DEEPFAKE_KEY_MEMBERS_ASYNC.SUCCESS,
  payload: { data },
})
export const getDeepfakeKeyMembersError = (error) => ({
  type: GET_DEEPFAKE_KEY_MEMBERS_ASYNC.ERROR,
  error,
})

export const createDeepfakeKeyMember = () => ({
  type: CREATE_DEEPFAKE_KEY_MEMBER_ASYNC.INITIATE,
})
export const createDeepfakeKeyMemberSuccess = (data) => ({
  type: CREATE_DEEPFAKE_KEY_MEMBER_ASYNC.SUCCESS,
  payload: { data },
})
export const createDeepfakeKeyMemberError = (error) => ({
  type: CREATE_DEEPFAKE_KEY_MEMBER_ASYNC.ERROR,
  error,
})

export const updateDeepfakeKeyMember = () => ({
  type: UPDATE_DEEPFAKE_KEY_MEMBER_ASYNC.INITIATE,
})
export const updateDeepfakeKeyMemberSuccess = (data) => ({
  type: UPDATE_DEEPFAKE_KEY_MEMBER_ASYNC.SUCCESS,
  payload: { data },
})
export const updateDeepfakeKeyMemberError = (error) => ({
  type: UPDATE_DEEPFAKE_KEY_MEMBER_ASYNC.ERROR,
  error,
})

export const setDeepfakeMailboxListPage = (page) => ({
  type: SET_DEEPFAKE_MAILBOX_LIST_PAGE,
  payload: { page },
})
export const setEmployeeInfo = (data) => ({
  type: SET_EMPLOYEE_INFO,
  payload: { data },
})
export const setEmployeeInfoField = (field, value) => ({
  type: SET_EMPLOYEE_INFO_FIELD,
  payload: { field, value },
})
export const setDeepfakeMailboxListValue = (value) => ({
  type: SET_DEEPFAKE_MAILBOX_LIST_VALUE,
  payload: { value },
})

export default {
  // to props
}
